const STORAGE_NS = "file_list_view_pref_v1";
const VIEW_MODE = {
  TABLE: "table",
  CARD: "card",
};
const ALLOWED_VIEW_MODES = [VIEW_MODE.TABLE, VIEW_MODE.CARD];
const DEFAULT_VIEW_MODE = VIEW_MODE.TABLE;

function isBrowser() {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

function keyOf(userId) {
  if (!userId) return null;
  return `${STORAGE_NS}:${userId}`;
}

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function normalizeViewMode(viewMode) {
  return ALLOWED_VIEW_MODES.includes(viewMode) ? viewMode : DEFAULT_VIEW_MODE;
}

export function getFileListViewPref(userId) {
  if (!isBrowser()) return DEFAULT_VIEW_MODE;

  const storageKey = keyOf(userId);
  if (!storageKey) return DEFAULT_VIEW_MODE;

  const raw = localStorage.getItem(storageKey);
  if (!raw) return DEFAULT_VIEW_MODE;

  const parsed = safeParse(raw);
  if (!parsed || parsed.v !== 1) return DEFAULT_VIEW_MODE;

  return normalizeViewMode(parsed.viewMode);
}

export function setFileListViewPref(userId, viewMode) {
  if (!isBrowser()) return;

  const storageKey = keyOf(userId);
  if (!storageKey) return;

  const payload = {
    v: 1,
    t: Date.now(),
    viewMode: normalizeViewMode(viewMode),
  };

  localStorage.setItem(storageKey, JSON.stringify(payload));
}

export const FILE_LIST_VIEW_PREF = {
  DEFAULT_VIEW_MODE,
  VIEW_MODE,
  ALLOWED_VIEW_MODES,
};
